import { MediaQueries } from '@hhgtech/hhg-components'
import { Text } from '@hhgtech/hhg-components/mantine'
import { Container, ContainerProps, SimpleGrid, Stack } from '@mantine/core'
import { useElementSize } from '@mantine/hooks'
import { useIntl } from 'react-intl'

import { HealthToolBreadcrumb } from 'components/molecules/healthToolBreadcrumb'
import { Sources } from 'components/molecules/sources'
import MobileBottomNavigationWrapper from 'components/organisms/mobileBottomNavigationWrapper'
import { useIsMobile } from 'hooks/useIsMobile'
import { useExpertStore } from 'state/expert'

import { _Certificate } from './_certificate'
import { _Education } from './_education'
import { _Experience } from './_experience'
import { _Information } from './_information'
import { _RelatedPostCards } from './_relatedPostCards'
import { _RelatedPosts } from './_relatedPosts'
import { StyledBorderHeading, StyledExpertDescription } from './index.styled'
export type _ExpertProps = ContainerProps

const _Expert = (props: _ExpertProps) => {
  const { formatMessage: f } = useIntl()
  const {
    currentExpert: expert,
    relatedCardPosts = [],
    relatedCardPostComments = [],
  } = useExpertStore((state) => ({
    currentExpert: state.currentExpert,
    relatedCardPosts: state.relatedCardPosts,
    relatedCardPostComments: state.relatedCardPostComments,
  }))
  const isMobile = useIsMobile()

  const { ref, height } = useElementSize()
  if (!expert) return null

  return (
    <Container fluid p={0} bg={'#e3f2ff'} {...props}>
      <Container fluid p={0} bg={'#ffffff'} pb={1}>
        <HealthToolBreadcrumb
          bg={'#ffffff'}
          pageItem={[
            {
              label: f({
                id: 'experts.allExperts',
                defaultMessage: 'Experts',
              }),
              value: `/expert`,
            },
            {
              label: expert.displayName,
              value: expert.profileUrl,
            },
          ]}
        />
      </Container>

      <_Information ref={ref} />
      <Container
        fluid
        bg="#ffffff"
        pt={height || 160}
        sx={{
          borderRadius: '20px 20px 0 0',
          [MediaQueries.mbUp]: { borderRadius: '40px 40px 0 0' },
        }}
      >
        <Container size="lg" px={0}>
          <Stack spacing={24} mb={48}>
            {!!expert.description && (
              <Stack spacing={16}>
                <StyledBorderHeading tag="h4">
                  {f({
                    id: 'expert.content.about',
                    defaultMessage: 'About',
                  })}
                </StyledBorderHeading>
                <Text as="div" size="p2">
                  <StyledExpertDescription
                    className="expert-description"
                    dangerouslySetInnerHTML={{ __html: expert.description }}
                  />
                </Text>
              </Stack>
            )}
            {!!(
              expert?.fields &&
              (expert.fields.educations ||
                expert.fields.experiences ||
                expert.fields.awards_accreditations)
            ) && (
              <Stack spacing={16}>
                <StyledBorderHeading tag="h4">
                  {f({
                    id: 'expert.content.highlight',
                    defaultMessage: 'Credentials & Highlights',
                  })}
                </StyledBorderHeading>
                <SimpleGrid cols={isMobile ? 1 : 3} spacing={24}>
                  <_Education />
                  <_Experience />
                  <_Certificate />
                </SimpleGrid>
              </Stack>
            )}
            {relatedCardPosts?.length + relatedCardPostComments?.length > 0 && (
              <Stack spacing={16}>
                <StyledBorderHeading tag="h4">
                  {f({
                    id: 'expert.content.relatedPosts',
                    defaultMessage: 'Related posts',
                  })}
                </StyledBorderHeading>
                <_RelatedPostCards />
              </Stack>
            )}
            {expert?.fields?.sources &&
              Array.isArray(expert?.fields?.sources) &&
              expert?.fields?.sources.length > 0 && (
                <Sources
                  title={f(
                    {
                      id: 'expert.content.publishedPapers',
                      defaultMessage: '{number} Published papers',
                    },
                    {
                      number: expert?.fields?.sources.length,
                    },
                  ).toUpperCase()}
                  sources={expert?.fields?.sources.map((s) =>
                    s.url ? `<a href="${s.url}">${s.title}</a>` : s.title,
                  )}
                />
              )}
            <_RelatedPosts mt={16} />
            {/* {expert.fields.policies && (
            <_Policies policies={expert.fields.policies} />
          )} */}
          </Stack>
        </Container>
        <MobileBottomNavigationWrapper />
      </Container>
    </Container>
  )
}

export default _Expert
